"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ImageBarTemplate = require("./ImageBarTemplate");

var _checkmark = _interopRequireDefault(require("../../../assets/checkmark.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var StyledCheck = _styledComponents.default.div.withConfig({
  displayName: "StyledCheck"
})(["width:1.9rem;height:1.9rem;min-width:1.9rem;display:flex;justify-content:center;align-items:center;border-radius:3px;margin:auto 2rem;border:1.2px solid;border-color:", ";", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.ui.outline;
}, function (_ref2) {
  var checked = _ref2.checked,
      theme = _ref2.theme;
  return checked ? (0, _styledComponents.css)(["background-color:", ";text-align:center;"], theme.brand.secondary) : null;
});

var StyledCheckmark = (0, _styledComponents.default)(_checkmark.default).withConfig({
  displayName: "StyledCheckmark"
})(["width:80%;margin:0 !important;"]);
var CheckOption = /*#__PURE__*/(0, _react.forwardRef)(function (_ref3, ref) {
  var checked = _ref3.checked,
      disabled = _ref3.disabled,
      name = _ref3.name,
      handleClick = _ref3.handleClick,
      handleChange = _ref3.handleChange,
      icon = _ref3.icon,
      children = _ref3.children,
      theme = _ref3.theme,
      otherProps = _objectWithoutProperties(_ref3, ["checked", "disabled", "name", "handleClick", "handleChange", "icon", "children", "theme"]);

  var onChange = function onChange(e) {
    e.persist();
    handleChange({
      name: e.target.name,
      value: e.target.value
    });
  };

  var onClick = function onClick(e) {
    e.persist();
    handleClick({
      name: e.target.name,
      value: e.target.value
    });
  };

  return /*#__PURE__*/_react.default.createElement(_ImageBarTemplate.Container, {
    checked: checked,
    disabled: disabled
  }, /*#__PURE__*/_react.default.createElement(_ImageBarTemplate.StyledInput, _extends({
    type: "checkbox",
    onClick: onClick,
    onChange: onChange,
    checked: checked,
    disabled: disabled,
    name: name,
    ref: ref
  }, otherProps)), icon, /*#__PURE__*/_react.default.createElement(_ImageBarTemplate.Text, null, children), /*#__PURE__*/_react.default.createElement(StyledCheck, {
    checked: checked
  }, checked && disabled ? /*#__PURE__*/_react.default.createElement(StyledCheckmark, {
    color: theme.colors.disabled
  }) : checked && !disabled ? /*#__PURE__*/_react.default.createElement(StyledCheckmark, {
    color: "white"
  }) : null));
});
CheckOption.displayName = 'CheckOption';
CheckOption.propTypes = {
  checked: _propTypes.default.bool.isRequired,
  disabled: _propTypes.default.bool,
  name: _propTypes.default.string,
  handleClick: _propTypes.default.func,
  handleChange: _propTypes.default.func,
  icon: _propTypes.default.elementType,
  children: _propTypes.default.node,
  theme: _propTypes.default.object
};
CheckOption.defaultProps = {
  checked: false,
  onChange: function onChange() {}
};
var _default = CheckOption;
exports.default = _default;